import React, { memo } from 'react';
import PropTypes from 'prop-types';

import License from 'components/Footer/License/License';

import Navigation from './Navigation';

const SignUpContent = ({ activeType, renderForm, setActiveType, types }) => (
  <>
    <Navigation activeType={activeType} onChange={setActiveType} types={types} />
    {renderForm}
    <div className="footer__copyright">
      <License EGamingIconSize={46} hasTitle={false} />
    </div>
  </>
);

SignUpContent.propTypes = {
  activeType: PropTypes.object,
  renderForm: PropTypes.node,
  setActiveType: PropTypes.func,
  types: PropTypes.arrayOf(PropTypes.object),
};

export default memo(SignUpContent);
